export default function msgErro(response) {

  let status = response.response.status;
  if (status === 403 && response.response.data.error === 'access_denied') {
    this.$toast.add({
      severity: "error",
      summary: "Atenção.",
      detail: "Voçê não tem permissão para esta operação.",
     
    });
    return;
  }

  let data = response.response.data[0];

  this.mensagemDesenvolvedor = response.response.data[0].mensagemDesenvolvedor;
  this.mensagemUsuario = response.response.data[0].mensagemUsuario;

  if (status >= 400) {
    this.$toast.add({
      severity: "error",
      summary: "Alerta de Erro.",
      detail: data.mensagemUsuario,
     
    });
  }

  let containing = this.mensagemDesenvolvedor.indexOf("NegocioException");
  let foreignKey = this.mensagemDesenvolvedor.indexOf(
    "java.sql.SQLIntegrityConstraintViolationException"
  );
  if (containing > -1) {
    let negocio = this.mensagemDesenvolvedor.replace(
      "br.gov.pa.saude.api.exceptionhandler.NegocioException:",
      ""
    );
    this.$toast.add({
      severity: "error",
      summary: "Alerta de Erro.",
      detail: negocio,
     
    });
  }
  if (foreignKey > -1) {
    this.$toast.add({
      severity: "error",
      summary: "Alerta de Erro.",
      detail: "Não é possivel excluir registros cujo estão dados atrelados.",
     
    });
  }
}